<template>
  <span class="ExchangeIcon" :title="title">
    <svg
      v-if="exchId === 1"
      title="Binance"
      :style="`width:${size}px;height:${size}px;`"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <path
        d="M230.997333 512L116.053333 626.986667 0 512l116.010667-116.010667L230.997333 512zM512 230.997333l197.973333 197.973334 116.053334-115.968L512 0 197.973333 314.026667l116.053334 115.968L512 230.997333z m395.989333 164.992L793.002667 512l116.010666 116.010667L1024.981333 512l-116.992-116.010667zM512 793.002667l-197.973333-198.997334-116.053334 116.010667L512 1024l314.026667-314.026667-116.053334-115.968L512 793.002667z m0-165.973334l116.010667-116.053333L512 396.032 395.989333 512 512 626.986667z"
        fill="#F0B90B"
      ></path>
    </svg>
    <svg
      v-else-if="exchId === 2"
      title="CoinBase Pro"
      :style="`width:${size}px;height:${size}px;`"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <rect width="1024" height="1024" rx="512" fill="#000"/>
      <path d="M512.147 692C412.697 692 332.146 611.45 332.146 512C332.146 412.55 412.697 332 512.147 332C601.247 332 675.197 396.95 689.447 482H870.797C855.497 297.2 700.846 152 512.147 152C313.396 152 152.146 313.25 152.146 512C152.146 710.75 313.396 872 512.147 872C700.846 872 855.497 726.8 870.797 542H689.297C675.047 627.05 601.247 692 512.147 692Z" fill="white"/>
    </svg>
    <img
      v-else
      :alt="title"
      :src="cointrackrLogo"
      :style="`width:${size}px;height:${size}px;`"
      class="ExchangeIcon__img"
    />
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import options from "@/options";
import cointrackrLogoNight from "@/static/touch-icon.png";

export default {
  name: "ExchangeIcon",
  props: {
    exchId: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    title() {
      return options.exchangesList[this.exchId].name;
    },
    cointrackrLogo() {
      return this.nightMode ? cointrackrLogoNight : "/favicon-not-empty.png";
    },
    ...mapGetters({
      nightMode: "settings/nightMode",
    }),
  },
};
</script>

<style>
.ExchangeIcon__img {
  user-select: none;
}
</style>
